module.exports = __webpack_public_path__ + "static/012.thumb-c6d31caee62998bc530182d42d89911d.jpg";